// Componente exibido quando o Sentry não está configurado

import { Cloud, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

export function SentryNotConfigured() {
  return (
    <Card className="border-dashed">
      <CardContent className="flex flex-col items-center justify-center py-16 text-center">
        <div className="rounded-full bg-purple-100 p-4 mb-4">
          <Cloud className="h-12 w-12 text-purple-500" />
        </div>
        
        <h2 className="text-xl font-semibold mb-2">
          Conecte o Sentry para ver métricas
        </h2>
        
        <p className="text-muted-foreground max-w-md mb-6">
          O painel de performance requer integração com o Sentry. 
          Configure o <code className="px-1.5 py-0.5 rounded bg-muted font-mono text-sm">SENTRY_AUTH_TOKEN</code> nas 
          variáveis de ambiente da Edge Function. O token do painel/admin e o token usado no build para releases/sourcemaps podem ser o mesmo ou separados.
        </p>

        <div className="flex flex-col sm:flex-row gap-3">
          <Button variant="outline" asChild>
            <a 
              href="https://sentry.io/settings/account/api/auth-tokens/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="gap-2"
            >
              <ExternalLink className="h-4 w-4" />
              Criar Token no Sentry
            </a>
          </Button>
          
          <Button variant="default" asChild>
            <a 
              href="https://supabase.com/dashboard/project/irtygpadfbavrqhldhzm/settings/functions" 
              target="_blank" 
              rel="noopener noreferrer"
              className="gap-2"
            >
              Configurar Secrets
            </a>
          </Button>
        </div>

        <div className="mt-8 p-4 rounded-lg bg-muted/50 text-left max-w-md">
          <p className="text-sm font-medium mb-2">Passos para configurar:</p>
          <ol className="text-sm text-muted-foreground space-y-1.5 list-decimal list-inside">
            <li>Crie um Auth Token no Sentry com escopos `project:read`, `event:write`, `project:releases` e `org:read`</li>
            <li>Acesse as configurações de Secrets no Supabase</li>
            <li>Adicione <code className="px-1 py-0.5 rounded bg-muted font-mono text-xs">SENTRY_AUTH_TOKEN</code></li>
            <li>Cole o token gerado e salve</li>
          </ol>
        </div>
      </CardContent>
    </Card>
  );
}
